import { render, staticRenderFns } from "./TrustedContacts.html?vue&type=template&id=54cefb31&scoped=true&external"
import script from "./TrustedContacts.js?vue&type=script&lang=js&external"
export * from "./TrustedContacts.js?vue&type=script&lang=js&external"
import style0 from "./TrustedContacts.vue?vue&type=style&index=0&id=54cefb31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cefb31",
  null
  
)

export default component.exports